import { render, staticRenderFns } from "./merchantNoticeManage.vue?vue&type=template&id=07eab2b5&scoped=true"
import script from "./merchantNoticeManage.vue?vue&type=script&lang=ts"
export * from "./merchantNoticeManage.vue?vue&type=script&lang=ts"
import style0 from "./merchantNoticeManage.vue?vue&type=style&index=0&id=07eab2b5&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07eab2b5",
  null
  
)

export default component.exports